import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import { LoaderWrapper, MuiMultiSelect, ReportHeading, ReportOuterWrapper } from '../../../../../components'
import ReportsService from '../../../../../services/reports.service'
import { useUpdateLhs, useReactQuery, useConditionalQuery } from '../../../../../hooks'
import { ContentWrap, Divider, RootWrap, SegmentOfSegmentWrap, GridWrapper, DropdownWrapper } from './style'
import { exportExcel_addPercentage, getObjectAsArray, trimFunc, getDistinctValues } from '../../../../../util'
import { IconGraphBtn, IconListBtn } from '../../../../../assets/images/icons'
import { GRAPH_COLOR_PALLET_V2, GRAPH_COLOR_PALLET_V2_TEXT } from '../../../../../constants'
import { ProgressionWrapper as ProgressWrapper } from '../../../../reports/components/reportCustomTable/style'
import { useGlobalStore } from '../../../../../store'
import GraphGridTab, { Table } from '../../../../reports/components/comparisonViewDeepDiveNew/graphGridTab'
import BuyerTable from '../../../../reports/components/segmentComparison/buyerTable'
import ProgressionBuyerTable from '../../../../reports/components/reportSegmentProgression/progressionBuyerTable'
import RelativeBrands from '../../../../reports/components/segmentOverview/relativeBrands'


const BarGrid = (props) => {
  const [graphPieData, setGraphPieData] = useState([])
  const [state, setState] = useState(props?.parentData || [])
  const [segmentExcelData, setSegmentExcelData] = useState([])
  const [reportExcelData, setReportExcelData] = useState([])
  const [eventCount, setEventCount] = useState(1)
  const { updateSubLhsApiLoaded } = useUpdateLhs()
  const [show , setShow] = useState('graph')
  const [checkBoxData , setCheckboxData] = useState([])
  const [segmentData , setSegmentData] = useState([])
  const [showComparison , setShowComparison] = useState('graph')
  const [maxValue, setMaxValue] = useState(0)
  const [allValuesShow, setAllValuesShow] = useState(true)
  const [segmentValues , setSegmentValues] = useState([])
  const [filterValue , setFilterValues] = useState([])
  const [pptData, setPptData] = useState()
  const [finalPptData, setFinalPptData] = useState(null)
  const [updateStateCount, setUpdateStateCount] = useState(0)
  // const [isTitleOrdered, setTitleOrderedArray] = useState([])
  const [colorPalletPieArray, setColorPalletPieArray] = useState([])
  const [sortedPieColorObject, setSortedPieColorObject] = useState({})

  const { isPPTModalActive } = useGlobalStore()
  const COLOR_ARRAY_NEW = [...GRAPH_COLOR_PALLET_V2, ...GRAPH_COLOR_PALLET_V2_TEXT, ...GRAPH_COLOR_PALLET_V2, ...GRAPH_COLOR_PALLET_V2_TEXT]
 
  const onBtnClick = (activeTab) => {
    setShow(activeTab)
  }

  const onCompareBtnClick = (activeTab) => {
    setShowComparison(activeTab)
  }
  
  const filterChangeFunc = (selectedValue) => {
    setAllValuesShow(prev => selectedValue.length > 0 ? true : false);
    const selectedValues = selectedValue.filter((val) => val !== 'All');

    let data = state?.map((elem) => {
      return {
        ...elem,
        SecondarySegmentSet: {
          ...elem.SecondarySegmentSet,
          SecondarySegment: getObjectAsArray(elem?.SecondarySegmentSet?.SecondarySegment).map((obj) => ({
            ...obj,
            SegmentName: String(obj.SegmentName),
            show: selectedValues.includes(obj.SegmentName)
          }))
        }
      };
    });

    setState(data);
    // setStateValue(data);
    setFilterValues(selectedValue);
  };

  const filterSegmentChangeFunc = (selectedValue) => {
    setAllValuesShow(prev => selectedValue.length > 0 ? true : false);
    const selectedValues = selectedValue.filter((val) => val !== 'All');

    let data = state?.map((elem) => {
      return {
        ...elem,
        SegmentName: String(elem.PrimarySegmentName),
        show: selectedValues.includes(elem.PrimarySegmentName)
      };
    });

    setState(data);
    // setStateValue(data);
    setSegmentValues(selectedValue);
  };

  // eventCount only needs incrementing when data initially loads — avoid scheduling on every state/graph change
  useEffect(() => {
    filterChangeFunc(checkBoxData);
  }, [checkBoxData])
    
  useEffect(() => {
    filterSegmentChangeFunc(segmentData);
  }, [segmentData])

  const settingDataFromPropsFunc = () => {
      const segmentNames = getObjectAsArray(props.parentData[0]?.SecondarySegmentSet?.SecondarySegment).map(i => String(i.SegmentName));
      setCheckboxData(segmentNames)
      
      const periodNames = props.parentData.map(i => String(i.PrimarySegmentName));
      setSegmentData(periodNames)
  }
  
  useEffect(() => {
    settingDataFromPropsFunc()
  }, [])

  return (
    <>
      {state?.length>0 && (
        <GridWrapper>

                  <ProgressWrapper>
                    <DropdownWrapper>
                      {checkBoxData.length > 0 && (
                        <MuiMultiSelect
                          name={checkBoxData.length}
                          placeholder={`Select Segments`}
                          onChange={(val) => filterChangeFunc(val)}
                          onSelectAll={(val) => {
                            const newVal = val ? checkBoxData : [];
                            filterChangeFunc(newVal);
                          }}
                          data={checkBoxData}
                          value={filterValue}
                          style={{ width: '100%' , maxWidth: '200px' }}
                          search={true}
                        />
                      )} 

                      {segmentData.length > 0 && (
                        <MuiMultiSelect
                          name={segmentData.length}
                          placeholder={`Select Period`}
                          onChange={(val) => filterSegmentChangeFunc(val)}
                          onSelectAll={(val) => {
                            const newVal = val ? segmentData : [];
                            filterSegmentChangeFunc(newVal);
                          }}
                          data={segmentData}
                          value={segmentValues}
                          style={{ width: '100%', maxWidth: '200px' }}
                          search={true}
                        />
                      )}
                    </DropdownWrapper>

                    <GraphGridTab onClick={onCompareBtnClick} show={showComparison} GraphIcon={Table} TableIcon={IconListBtn} disableActiveBg={true} />
                  </ProgressWrapper>

                  {state?.length > 0 && (
                    <Box className='customImageRow'><ProgressionBuyerTable
                      view={showComparison}
                      isExtraColor={true}
                      data={state}
                      showLegendToolTip={true}
                      allValuesShow={allValuesShow}
                      insightsElementType={'SegmentAndSegmentProgression'}
                    /></Box>
                  )}
 
        </GridWrapper>
      )}
    </>
  )
}

export default BarGrid
